import {SwiperElement} from "js/swiper/swiper"

export {}

const serviceSections = document.querySelectorAll(".s-services")

function initializeCustomBullets() {
  if (serviceSections) {
    serviceSections.forEach((serviceSection) => {
      const swiperElement = serviceSection.querySelector<SwiperElement>(".g-services-slider")
      const customBullets = serviceSection.querySelectorAll(".i-swiper-switcher")

      if (!swiperElement) return
      if (customBullets[0]) customBullets[0].classList.add("--active")

      customBullets.forEach((bullet, index) => {
        bullet.addEventListener("click", () => {
          if (swiperElement.swiper) swiperElement.swiper.slideTo(index)
        })
      })

      if (swiperElement.swiper) {
        swiperElement.swiper.on("slideChange", () => {
          // Remove "--active" class from all bullets
          customBullets.forEach((bullet) => {
            bullet.classList.remove("--active")
          })

          if (!swiperElement.swiper) return

          const currentBullet = customBullets[swiperElement.swiper.realIndex]

          if (currentBullet) {
            currentBullet.classList.add("--active")
          }
        })
      }
    })
  }
}

document.addEventListener("swiperServicesLoaded", initializeCustomBullets)
